import Chart from "react-apexcharts";
import { colors } from "../../global";

const AvgTimeToCloseByVerticalMonth = ({ data }) => {
  const chartData = data;
  if (!chartData || !chartData.categories) return null;

  const chartColors = [
    colors.primary,
    colors.accent,
    colors.tertiary,
    "#4CAF50",
    "#9C27B0",
    "#03A9F4",
  ];

  return (
    <>
      <h2 className="text-lg font-semibold mb-4">
        Average Time to Close by Vertical (Monthly)
      </h2>
      <Chart
        options={{
          chart: {
            type: "line",
            toolbar: { show: false },
          },
          stroke: { curve: "smooth", width: 3 },
          xaxis: {
            categories: chartData.categories,
            title: { text: "Vertical" },
            labels: { rotate: -25, style: { fontSize: "12px" } },
          },
          yaxis: {
            title: { text: "Average Days to Close" },
            labels: { formatter: (v) => v.toFixed(1) },
          },
          legend: {
            position: "top",
            horizontalAlign: "center",
            fontSize: "13px",
          },
          colors: chartColors.slice(0, chartData.series.length),
          markers: { size: 4 },

          tooltip: {
            shared: true,
            y: { formatter: (v) => `${v.toFixed(2)} days` },
          },
          dataLabels: {
            enabled: true,
            formatter: (val) => `${val.toFixed(1)} days`,
            offsetY: -10,
            style: {
              fontSize: "11px",
              fontWeight: "bold",
            },
          },
        }}
        series={chartData.series}
        type="line"
        height={380}
      />
    </>
  );
};

export default AvgTimeToCloseByVerticalMonth;
